import React, { Component } from 'react';
import '../styles/Menu.css';
import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  Divider,
  ListItemIcon,
  IconButton,
  ListSubheader
} from '@mui/material';
import { Link, withRouter } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LanguageIcon from '@mui/icons-material/Language';
import LayersIcon from '@mui/icons-material/Layers';
import TopicIcon from '@mui/icons-material/Topic';
import ArticleIcon from '@mui/icons-material/Article';
import GroupIcon from '@mui/icons-material/Group';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import RedoIcon from '@mui/icons-material/Redo';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PostAddIcon from '@mui/icons-material/PostAdd';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import AssignmentIcon from '@mui/icons-material/Assignment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import CampaignIcon from '@mui/icons-material/Campaign';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = { mobileOpen: true };
    this.toggleMobile = this.toggleMobile.bind(this);
    this.handleNavClick = this.handleNavClick.bind(this);
  }

  toggleMobile() {
    this.setState((s) => ({ mobileOpen: !s.mobileOpen }));
  }

  handleNavClick() {
    // Referme le menu sur mobile après navigation
    this.setState({ mobileOpen: false });
  }

  isActive(pathname, match) {
    if (typeof match === 'function') return match(pathname);
    if (Array.isArray(match)) return match.some((m) => this.isActive(pathname, m));
    return pathname === match || pathname.startsWith(match);
  }

  render() {
    const { mobileOpen } = this.state;
    const pathname = this.props.location ? this.props.location.pathname : '';

    return (
      <Box
        sx={{
          width: '100%',
          bgcolor: 'background.paper',
          borderRight: { md: 1 },
          borderColor: 'divider',
          borderRadius: 1,
          boxShadow: { xs: 1, md: 0 },
          overflow: 'hidden'
        }}
      >
        {/* En-tête contrasté */}
        <Box
          sx={{
            p: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            position: 'sticky',
            top: 0,
            zIndex: 1,
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4
          }}
        >
          <Typography
            variant="h6"
            component={Link}
            to="/super-admin/"
            onClick={this.handleNavClick}
            sx={{
              textDecoration: 'none',
              color: 'inherit',
              fontWeight: 700,
              letterSpacing: 1
            }}
          >
            SEMIOLOGIC
          </Typography>

          {/* Bouton hamburger mobile */}
          <IconButton
            color="inherit"
            size="small"
            onClick={this.toggleMobile}
            sx={{ display: { xs: 'inline-flex', md: 'none' } }}
            aria-label="Ouvrir/fermer le menu"
          >
            <MenuIcon />
          </IconButton>
        </Box>

        <Divider />

        {/* Liste repliable sur mobile */}
        <Box
          sx={{
            display: { xs: mobileOpen ? 'block' : 'none', md: 'block' },
            overflowY: { xs: 'auto', md: 'visible' }
          }}
        >
          {/* Tableau de bord */}
          <List
            component="nav"
            subheader={<ListSubheader component="div">Tableau de bord</ListSubheader>}
          >
            <ListItemButton
              component={Link}
              to="/super-admin/"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/')}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><DashboardIcon /></ListItemIcon>
              <ListItemText primary="Accueil" />
            </ListItemButton>
          </List>

          <Divider />

          {/* Contenus */}
          <List
            component="nav"
            subheader={<ListSubheader component="div">Contenus</ListSubheader>}
          >
            <ListItemButton
              component={Link}
              to="/super-admin/website"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/website')}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><LanguageIcon /></ListItemIcon>
              <ListItemText primary="Communauté" />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/super-admin/Thread"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, ['/super-admin/Thread', '/super-admin/thread'])}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><LayersIcon /></ListItemIcon>
              <ListItemText primary="Pages GC" />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/super-admin/Pagesgd"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/Pagesgd')}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><TopicIcon /></ListItemIcon>
              <ListItemText primary="Sujets GD" />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/super-admin/Listenews"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/Listenews')}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><ArticleIcon /></ListItemIcon>
              <ListItemText primary="Éditeur de News" />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/super-admin/Formnews"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/Formnews')}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><PostAddIcon /></ListItemIcon>
              <ListItemText primary="Créer une News" />
            </ListItemButton>
          </List>

          <Divider />

          {/* Communication */}
          <List
            component="nav"
            subheader={<ListSubheader component="div">Communication</ListSubheader>}
          >
            <ListItemButton
              component={Link}
              to="/super-admin/ListAnnouncements"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/ListAnnouncements')}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><CampaignIcon /></ListItemIcon>
              <ListItemText primary="Annonces" />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/super-admin/FormAnnouncement"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/FormAnnouncement')}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><AddCircleOutlineIcon /></ListItemIcon>
              <ListItemText primary="Nouvelle annonce" />
            </ListItemButton>
          </List>

          <Divider />

          {/* Acquisition */}
          <List
            component="nav"
            subheader={<ListSubheader component="div">Acquisition</ListSubheader>}
          >
            <ListItemButton
              component={Link}
              to="/super-admin/funnel"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/funnel')}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><FilterAltIcon /></ListItemIcon>
              <ListItemText primary="Funnel d'acquisition" />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/super-admin/deactivation-feedback"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/deactivation-feedback')}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><FeedbackOutlinedIcon /></ListItemIcon>
              <ListItemText primary="Feedbacks de désinstallation" />
            </ListItemButton>

            {/* Suivi du parc Google Sites (google-sites-install B4_01) — page de consultation,
                ⛔ sans pastille (D51) */}
            <ListItemButton
              component={Link}
              to="/super-admin/hosting-detected"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/hosting-detected')}
              sx={{ py: 1.25 }}
              data-testid="menu-hosting-detected"
            >
              <ListItemIcon><TravelExploreIcon /></ListItemIcon>
              <ListItemText primary="Google Sites" />
            </ListItemButton>
          </List>

          <Divider />

          {/* Modération */}
          <List
            component="nav"
            subheader={<ListSubheader component="div">Modération</ListSubheader>}
          >
            <ListItemButton
              component={Link}
              to="/super-admin/moderation-ia"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/moderation-ia')}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><SmartToyOutlinedIcon /></ListItemIcon>
              <ListItemText primary="Modération IA" />
            </ListItemButton>
          </List>

          <Divider />

          {/* Utilisateurs & Billing */}
          <List
            component="nav"
            subheader={<ListSubheader component="div">Utilisateurs & Billing</ListSubheader>}
          >
            <ListItemButton
              component={Link}
              to="/super-admin/User"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/User')}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><GroupIcon /></ListItemIcon>
              <ListItemText primary="Utilisateurs" />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/super-admin/Bills"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/Bills')}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><ReceiptLongIcon /></ListItemIcon>
              <ListItemText primary="Transactions" />
            </ListItemButton>
          </List>

          <Divider />

          {/* Outils & Stats */}
          <List
            component="nav"
            subheader={<ListSubheader component="div">Outils & Statistiques</ListSubheader>}
          >


            <ListItemButton
              component={Link}
              to="/super-admin/StatViews"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/StatViews')}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><ShowChartIcon /></ListItemIcon>
              <ListItemText primary="Statistiques" />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/super-admin/blocs-affiches"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/blocs-affiches')}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><WidgetsOutlinedIcon /></ListItemIcon>
              <ListItemText primary="Blocs affichés" />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/super-admin/Redirection"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/Redirection')}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><RedoIcon /></ListItemIcon>
              <ListItemText primary="Redirections" />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/super-admin/website/delete"
              onClick={this.handleNavClick}
              selected={this.isActive(pathname, '/super-admin/website/delete')}
              sx={{ py: 1.25 }}
            >
              <ListItemIcon><DeleteOutlineIcon /></ListItemIcon>
              <ListItemText primary="Communauté supprimée" />
            </ListItemButton>
          </List>
        </Box>
      </Box>
    );
  }
}

export default withRouter(Menu);

